import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const rangeAnalysisService = createApi({
  reducerPath: "rangeAnalysis",
  baseQuery,
  endpoints: (builder) => ({
    rangeAnalysis: builder.mutation({
      query: (formdata) => ({
        url: `/api/users/rangeanalysis`,
        method: "POST",
        body: formdata,
      }),
    }),
  }),
});
export const { useRangeAnalysisMutation } = rangeAnalysisService;
